import { render, staticRenderFns } from "./ActionRenderer.vue?vue&type=template&id=065dd6f5&scoped=true"
import script from "./ActionRenderer.vue?vue&type=script&lang=ts"
export * from "./ActionRenderer.vue?vue&type=script&lang=ts"
import style0 from "./ActionRenderer.vue?vue&type=style&index=0&id=065dd6f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065dd6f5",
  null
  
)

export default component.exports